export default __webpack_public_path__ + "static/media/logo.3228b455.svg";